export default __webpack_public_path__ + "static/media/Brick.460066c4.svg";